// extracted by mini-css-extract-plugin
export default {"section_3":"Section3_section_3__TOK-E","section_3_title":"Section3_section_3_title__bsxp+","cards":"Section3_cards__DV2uD"};